module.exports = __webpack_public_path__ + "img/Storing your goods by our well trained employees resized.8e26bc34.jpg";